module.exports = __webpack_public_path__ + "assets/dec5aadf1e6190fe0cf7be20b02ad82d.gif";